module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['lr2-modal', {
      'hide': !_vm.show
    }]
  }, [_c('div', {
    staticClass: "lr-box"
  }, [_c('div', {
    staticClass: "lr-header d-flex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "lr-title"
  }, [_vm._v("Flight Details")]), _vm._v(" "), _c('i', {
    staticClass: "far fa-times-circle fa-2x",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), (_vm.isReturning && _vm.leg1Flight.length > 1 && _vm.leg2Flight.length > 1) ? _c('div', {
    staticClass: "fl-tabs d-flex"
  }, [_c('div', {
    class: ['fl-tab', {
      active: _vm.active === 'leg1'
    }],
    on: {
      "click": function($event) {
        _vm.active = 'leg1'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.leg1Flight[0].logo
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n          " + _vm._s(_vm.leg1Flight[0].origin.CityName) + "\n          -\n          " + _vm._s(_vm.leg1Flight[_vm.leg1Flight.length - 1].destination.CityName) + "\n        ")])]), _vm._v(" "), _c('div', {
    class: ['fl-tab', {
      active: _vm.active === 'leg2'
    }],
    on: {
      "click": function($event) {
        _vm.active = 'leg2'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.leg2Flight[0].logo
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n          " + _vm._s(_vm.leg2Flight[0].origin.CityName) + "\n          -\n          " + _vm._s(_vm.leg2Flight[_vm.leg2Flight.length - 1].destination.CityName) + "\n        ")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.leg1Flight), function(flight, i) {
    return (_vm.active === 'leg1') ? _c('div', [_c('div', {
      staticClass: "flight-of"
    }, [_vm._v("Flight " + _vm._s(i + 1) + " of " + _vm._s(_vm.leg1Flight.length))]), _vm._v(" "), _c('div', {
      staticClass: "flight-box"
    }, [_c('div', {
      staticClass: "fl-no d-flex align-center"
    }, [_c('img', {
      attrs: {
        "src": flight.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(((flight.airline.name) + " " + (flight.airline.code) + (flight.flightNo))))])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-stretch fl-data"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "flight-text"
    }, [_c('div', {
      staticClass: "fl-city"
    }, [_vm._v(_vm._s(flight.origin.CityName))]), _vm._v(" "), _c('div', {
      staticClass: "fl-airport"
    }, [_vm._v(_vm._s(((flight.origin.AirportName) + " (" + (flight.origin.AirportCode) + ")")))]), _vm._v(" "), (flight.origin.Terminal) ? _c('div', {
      staticClass: "fl-airport"
    }, [_vm._v("Terminal " + _vm._s(flight.origin.Terminal))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "travel-time"
    }, [_vm._v("Travel Time: " + _vm._s(_vm.timeDiff(flight.origin.DateTime, flight.destination.DateTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "flight-date"
    }, [_c('div', {
      staticClass: "fl-time"
    }, [_vm._v(_vm._s(_vm.timeFormat(flight.origin.DateTime)))]), _vm._v(" "), _c('div', {
      staticClass: "fl-day"
    }, [_vm._v(_vm._s(_vm.dateFormat(flight.origin.DateTime)))])])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-stretch fl-data"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "flight-text"
    }, [_c('div', {
      staticClass: "fl-city"
    }, [_vm._v(_vm._s(flight.destination.CityName))]), _vm._v(" "), _c('div', {
      staticClass: "fl-airport"
    }, [_vm._v(_vm._s(((flight.destination.AirportName) + " (" + (flight.destination.AirportCode) + ")")))]), _vm._v(" "), (flight.destination.Terminal && flight.destination.Terminal !== 0) ? _c('div', {
      staticClass: "fl-airport"
    }, [_vm._v("Terminal " + _vm._s(flight.destination.Terminal))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flight-date"
    }, [_c('div', {
      staticClass: "fl-time"
    }, [_vm._v(_vm._s(_vm.timeFormat(flight.destination.DateTime)))]), _vm._v(" "), _c('div', {
      staticClass: "fl-day"
    }, [_vm._v(_vm._s(_vm.dateFormat(flight.destination.DateTime)))])])])]), _vm._v(" "), (i < _vm.leg1Flight.length - 1) ? _c('div', {
      staticClass: "layover-box"
    }, [_c('i', {
      staticClass: "far fa-clock"
    }), _vm._v(" "), _c('b', [_vm._v("\n          " + _vm._s(_vm.timeDiff(flight.destination.DateTime, _vm.leg1Flight[i + 1].origin.DateTime)) + " \n          layover in \n          " + _vm._s(_vm.leg1Flight[i + 1].origin.CityName) + "\n        ")])]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.leg2Flight), function(flight, i) {
    return (_vm.active === 'leg2') ? _c('div', [_c('div', {
      staticClass: "flight-of"
    }, [_vm._v("Flight " + _vm._s(i + 1) + " of " + _vm._s(_vm.leg2Flight.length))]), _vm._v(" "), _c('div', {
      staticClass: "flight-box"
    }, [_c('div', {
      staticClass: "fl-no d-flex align-center"
    }, [_c('img', {
      attrs: {
        "src": flight.logo
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(((flight.airline.name) + " " + (flight.airline.code) + (flight.flightNo))))])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-stretch fl-data"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "flight-text"
    }, [_c('div', {
      staticClass: "fl-city"
    }, [_vm._v(_vm._s(flight.origin.CityName))]), _vm._v(" "), _c('div', {
      staticClass: "fl-airport"
    }, [_vm._v(_vm._s(((flight.origin.AirportName) + " (" + (flight.origin.AirportCode) + ")")))]), _vm._v(" "), (flight.origin.Terminal) ? _c('div', {
      staticClass: "fl-airport"
    }, [_vm._v("Terminal " + _vm._s(flight.origin.Terminal))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "travel-time"
    }, [_vm._v("Travel Time: " + _vm._s(_vm.timeDiff(flight.origin.DateTime, flight.destination.DateTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "flight-date"
    }, [_c('div', {
      staticClass: "fl-time"
    }, [_vm._v(_vm._s(_vm.timeFormat(flight.origin.DateTime)))]), _vm._v(" "), _c('div', {
      staticClass: "fl-day"
    }, [_vm._v(_vm._s(_vm.dateFormat(flight.origin.DateTime)))])])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-stretch fl-data"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "flight-text"
    }, [_c('div', {
      staticClass: "fl-city"
    }, [_vm._v(_vm._s(flight.destination.CityName))]), _vm._v(" "), _c('div', {
      staticClass: "fl-airport"
    }, [_vm._v(_vm._s(((flight.destination.AirportName) + " (" + (flight.destination.AirportCode) + ")")))]), _vm._v(" "), (flight.destination.Terminal && flight.destination.Terminal !== 0) ? _c('div', {
      staticClass: "fl-airport"
    }, [_vm._v("Terminal " + _vm._s(flight.destination.Terminal))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flight-date"
    }, [_c('div', {
      staticClass: "fl-time"
    }, [_vm._v(_vm._s(_vm.timeFormat(flight.destination.DateTime)))]), _vm._v(" "), _c('div', {
      staticClass: "fl-day"
    }, [_vm._v(_vm._s(_vm.dateFormat(flight.destination.DateTime)))])])])]), _vm._v(" "), (i < _vm.leg2Flight.length - 1) ? _c('div', {
      staticClass: "layover-box"
    }, [_c('i', {
      staticClass: "far fa-clock"
    }), _vm._v(" "), _c('b', [_vm._v("\n          " + _vm._s(_vm.timeDiff(flight.destination.DateTime, _vm.leg2Flight[i + 1].origin.DateTime)) + " \n          layover in \n          " + _vm._s(_vm.leg2Flight[i + 1].origin.CityName) + "\n        ")])]) : _vm._e()]) : _vm._e()
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-line d-flex flex-column"
  }, [_c('div', {
    staticClass: "tl-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "tl-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-line d-flex flex-column"
  }, [_c('div', {
    staticClass: "tl-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "tl-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-line d-flex flex-column"
  }, [_c('div', {
    staticClass: "tl-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "tl-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-line d-flex flex-column"
  }, [_c('div', {
    staticClass: "tl-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "tl-line"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-27ca8a14", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27ca8a14","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DItinerary/FlightDetailsModal.vue
// module id = 2059
// module chunks = 0